let isSubscriptionExpiredRedirecting = false;

export const isSubscriptionExpired = (item) => {
  
  if (typeof item?.isSubscriptionExpired === 'boolean') return item.isSubscriptionExpired;

  const expiryDate = parseInt(item?.subscriptionExpiryDate || 0);
  return Boolean(expiryDate && Date.now() > expiryDate);
};

export const getExpiredLeagueAccessInfo = (pathname, leagues = [], teams = [], user = null) => {
  
  const match = pathname?.match(/^\/league\/([^/]+)(?:\/team\/([^/]+))?/);

  if (!match) return null;

  const leagueId = parseInt(match[1]);
  const teamId = match[2] ? parseInt(match[2]) : null;
  const league = leagues?.find((item) => parseInt(item?.id) === leagueId);
  const team = teamId ? teams?.find((item) => parseInt(item?.id) === teamId) : null;
  const leagueTeam = teams?.find((item) => parseInt(item?.leagueId) === leagueId);
  const target = league || team || leagueTeam;

  if (!target || !isSubscriptionExpired(target)) return null;

  return {
    leagueId,
    isSubscriptionPage: pathname === `/league/${leagueId}/subscription` || pathname === `/league/${leagueId}/subscription/`,
    canManageSubscription: Boolean(user?.isSuperAdmin || league),
  };
};

export const handleSubscriptionExpiredResponse = (response, constants) => {
  
  if (response?.data?.code !== 'SUBSCRIPTION_EXPIRED') return response;

  const leagueId = response?.data?.data?.leagueId;
  const pathname = window.location.pathname;

  if (!leagueId || pathname === '/subscription-expired' || pathname === `/league/${leagueId}/subscription`) {
    response.data.message = null;
    return response;
  };

  if (!isSubscriptionExpiredRedirecting) {
    
    isSubscriptionExpiredRedirecting = true;
    
    const user = JSON.parse(window.localStorage.getItem(constants.ASYNC_STORAGE_KEYS.USER_CORE_PROPERTIES) || 'null');
    const leagues = JSON.parse(window.localStorage.getItem(constants.ASYNC_STORAGE_KEYS.LEAGUE_DATA) || '[]');
    const canManageSubscription = Boolean(
      user?.isSuperAdmin ||
      leagues?.find((item) => parseInt(item?.id) === parseInt(leagueId))
    );

    window.location.replace(canManageSubscription ? `/league/${leagueId}/subscription` : '/subscription-expired');
  };

  response.data.message = null;
  return response;
};
